import { useOfflineToast } from './useOfflineToast';

/**
 * Hook to check if file uploads should be restricted due to offline mode
 *
 * File uploads are disabled when offline because:
 * - Attachments require server storage
 * - Base64 file data is too large for offline queue
 * - API calls cannot be made without network connection
 *
 * @returns {Object} Object containing offline status and upload restriction flag
 */
export const useOfflineFileRestriction = () => {
  const { isOnline } = useOfflineToast();

  return {
    isOffline: !isOnline,
    shouldDisableUploads: !isOnline,
  };
};
